import React, { useEffect, useState } from "react";
import { removeStorageKey } from "../utils";

/**
 * @param {string} key
 * @returns string;
 */
export function useMessageError(key) {
	const [message, setMessage] = useState(null);

	useEffect(() => {
		if (!key) return;

		setMessage(localStorage.getItem(key));

		if (localStorage.getItem(key) && !localStorage.getItem("tm:TIME")) {
			localStorage.setItem("tm:TIME", new Date().getMinutes());
			_timerForRemove();
		}
	}, [key]);

	function _timerForRemove() {
		const interval = setInterval(() => {
			const lastMinutes = parseInt(localStorage.getItem("tm:TIME"));
			const current = new Date().getMinutes();
			const minTime = Math.abs(lastMinutes - current) === 3;

			if (minTime) {
				const remove = ["tm:TIME", key];

				for (let value of remove) {
					removeStorageKey(value);
				}

				clearInterval(interval);
			}
		}, 60000);
	}

	return message;
}
